import { FC } from "react";

import { Button } from "~/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "~/components/ui/dialog";

interface ExportDocListDialogProps {
  isOpen: boolean;
  onClose: () => void;
  fileName: string;
}

const ExportPreview = () => {
  return (
    <div className="w-full max-w-[377px] h-40 relative bg-muted rounded-lg overflow-hidden">
      <div className="w-[calc(100%-16px)] max-w-[361px] h-36 px-4 py-[21px] left-[8px] top-[8px] absolute bg-background rounded flex-col justify-start items-start gap-2.5 inline-flex">
        <div className="h-[71px] flex-col justify-start items-start gap-4 flex">
          <img
            src="https://cdn.prod.website-files.com/66ffd2eb652c51f422cc31e8/670407a54344c0c196188cc0_Logo.png"
            alt="Sky Logo"
            className="h-[19.05px]"
          />
          <div className=" text-foreground text-base font-semibold leading-none">
            Export Started
          </div>
          <div className=" h-[39px] flex-col justify-start items-start gap-1.5 flex">
            <div className=" h-[9px] w-[248px] bg-muted rounded-lg" />
            <div className=" h-[9px] w-[296px] bg-muted rounded-lg" />
            <div className=" h-[9px] w-44 bg-muted rounded-lg" />
          </div>
        </div>
      </div>
    </div>
  );
};

export const ExportDocListDialog: FC<ExportDocListDialogProps> = ({
  isOpen,
  onClose,
  fileName,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="w-full max-w-[425px]">
        <DialogHeader>
          <DialogTitle className="flex items-center justify-between">
            Exporting Your Document
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-6">
          <ExportPreview />
          <div className="space-y-4 text-sm text-muted-foreground">
            <p>
              Check your email.{" "}
              <span>
                The export file will be ready soon, depending on size.
              </span>
            </p>
            <p>Sky AI has begun exporting your document:</p>
            <ul className="list-inside list-disc">
              <li>{fileName || "name of the file goes here.pdf"}</li>
            </ul>
          </div>
          <div className="flex justify-end">
            <Button onClick={onClose}>Close</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
